import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getAvailableLot = createAsyncThunk(
    '/user/available-lot-list',
    async (payload) => {
        try {
            const myurl = `${V_URL}/prosafe/available-lot-list`;
            const response = await axios({
                method: 'post',
                url: myurl,
                data: payload,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const piece = response.data;

            if (piece.success === true) {
                return piece;
            } else {
                throw new Error(piece);
            }
        } catch (error) {
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const getAvailableLotSlice = createSlice({
    name: "getAvailableLot",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAvailableLot.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAvailableLot.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getAvailableLot.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getAvailableLotSlice.reducer;